import { render, staticRenderFns } from "./AppInputTextAdd.vue?vue&type=template&id=5388d750"
import script from "./AppInputTextAdd.vue?vue&type=script&lang=js"
export * from "./AppInputTextAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports